import React from 'react';
import {
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { LinkContainer } from 'react-router-bootstrap';
import URI from 'urijs';

// containers
import BrokerageSearch from './Search/BrokerageSearch';
import ServiceCompanySearch from './Search/ServiceCompanySearch';

// components
import { MEMBER_TYPE_MAP } from '../../ducks/OfficeSearch';

// modules
import BS from '../../theme/Bootstrap';

let SearchForm = props => {
  const { initialValues } = props;
  const officeType = initialValues.officeType || 'brokerage';

  return renderMemberTypeForm({
    officeType,
    ...props
  });
};

const renderMemberTypeForm = props => {
  const { officeType } = props;

  switch (officeType) {
    case 'brokerage':
    default:
      return (
        <BrokerageSearch {...props}>{renderProviderDropdown(props)}</BrokerageSearch>
      );
    case 'service_company':
      return (
        <ServiceCompanySearch {...props}>
          {renderProviderDropdown(props)}
        </ServiceCompanySearch>
      );
  }
};

const renderProviderDropdown = ({ officeType }) => (
  <InputGroup className={`${BS.inputGroupGutter} ${BS.pb2}`}>
    <UncontrolledButtonDropdown>
      <DropdownToggle color="dark-blue" outline caret>
        {MEMBER_TYPE_MAP[officeType].label}
      </DropdownToggle>
      <DropdownMenu>
        {Object.keys(MEMBER_TYPE_MAP).map((key, i) => (
          <LinkContainer
            to={URI(MEMBER_TYPE_MAP[key].url).toString()}
            isActive={() => officeType === key}
            key={i}
          >
            <DropdownItem>{MEMBER_TYPE_MAP[key].label}</DropdownItem>
          </LinkContainer>
        ))}
      </DropdownMenu>
    </UncontrolledButtonDropdown>
    <span className={`${BS.ml2} ${BS.mr3}`}>|</span>
  </InputGroup>
);

const OfficeSearchForm = reduxForm({
  form: 'office-search-form'
})(SearchForm);

export default OfficeSearchForm;



// WEBPACK FOOTER //
// ./src/containers/OfficeSearch/OfficeSearchForm.js